import React from 'react'
import {
  Create,
  SimpleForm,
  TextInput,
  NumberInput,
  RadioButtonGroupInput,
  ReferenceInput,
  SelectInput,
  required,
  minLength,
  email,
  BooleanInput,
  FormDataConsumer,
} from 'react-admin'
import { EmailVerificationInfoAlert } from '../../components/EmailVerificationAlerts';
import Permission from '../../components/Permission';
import { PERMISSIONS } from '../../constants';

const validate = [required()];
const validateEmail = [required(), email()]
const validatePassword = [required(), minLength(6)];

export default props => {
  return (
    <Permission permission={PERMISSIONS.CREATE_USER}>
      <Create {...props} resource="employees" title="Cadastrar novo usuário" redirect="/system-users">
        <SimpleForm defaultValues={{ type: 'admin' }} sx={{ maxWidth: 600 }}>
          <TextInput source="name" label="Nome" validate={[required()]} InputProps={{ autoComplete: 'off' }} sx={{ minWidth: 300 }} />
          <TextInput source="login" label="Login" validate={validateEmail} InputProps={{ autoComplete: 'off' }} sx={{ minWidth: 300 }} />
          <TextInput source="password" label="Senha" validate={validatePassword} InputProps={{ autoComplete: 'new-password' }} sx={{ minWidth: 300 }} />
          <NumberInput source="maxPoints" label="Pontos por CPF" InputProps={{ autoComplete: 'off' }} sx={{ minWidth: 300 }} />
          <FormDataConsumer>
            {({ formData }) => (
              <ReferenceInput
                sx={{ width: 220 }}
                source="profileId"
                reference="profiles"
                sort={{ field: 'name', order: 'ASC' }}
                perPage={9999}
                filter={{ type: 'admin' }}>
                <RadioButtonGroupInput label="Perfil" optionText="name" validate={[required()]} />
              </ReferenceInput>
            )}
          </FormDataConsumer>
          <BooleanInput source="mustChangePassword" label="Forçar usuário a trocar senha no primeiro acesso" />
          <EmailVerificationInfoAlert />
        </SimpleForm>
      </Create>
    </Permission>
  )
}